import { render, staticRenderFns } from "./DeckTab.vue?vue&type=template&id=2d72369f&"
import script from "./DeckTab.ts?vue&type=script&lang=ts&"
export * from "./DeckTab.ts?vue&type=script&lang=ts&"
import style0 from "./DeckTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports